export function extractUuidFromUri(uri: string | undefined | null): string | null {
  if (!uri) {
    return null
  }
  const indexOfSlash = uri.lastIndexOf('/')
  return uri.substring(indexOfSlash + 1)
}
